// export function openNav() {
//   const $hamburger = $('.js-hamburger');
//   const $nav = $('.js-hamburger-nav');
//   const $body = $('body');
//   const $imgWhite = $('.js-reverseHeader_img-white');
//   const $imgBlack = $('.js-reverseHeader_img-black');
//   const $logoWrap = $('.js-reverse_wrap');

//   $hamburger.on('click', function () {
//     $(this).toggleClass('is-active');
//     $nav.toggleClass('is-active');
//     $body.toggleClass('is-fixed');
//     // $logoWrap.delay(300).toggleClass('is-show');
//     if ($nav.hasClass('is-active')) {
//       setTimeout(function () {
//         $logoWrap.toggleClass('is-show');
//       }, 500);
//     } else {
//       $logoWrap.toggleClass('is-show');
//     }

//     if ($('.js-reverseHeader').hasClass('-reverse')) {
//       $imgWhite.toggleClass('is-show');
//       $imgBlack.toggleClass('is-show');
//     }
//   });
// }
export function openNav() {
  const $hamburger = $('.js-hamburger');
  const $nav = $('.js-hamburger-nav');
  const $body = $('body');
  const $imgWhite = $('.js-reverseHeader_img-white');
  const $imgBlack = $('.js-reverseHeader_img-black');
  const $logoWrap = $('.js-reverse_wrap');
  let scrollPosition;

  // Set a custom property with the height of the viewport
  function setVhProperty() {
    let vh = $(window).innerHeight() * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  // Listen to the resize event and update the viewport height accordingly
  $(window).on('resize', function () {
    // If the hamburger menu is open, fix the viewport height to the height of the device
    if ($body.hasClass('is-fixed')) {
      setVhProperty();
    } else {
      // If the hamburger menu is not open, set the viewport height dynamically
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  });

  $hamburger.on('click', function () {
    $(this).toggleClass('is-active');
    $nav.toggleClass('is-active');
    $body.toggleClass('is-fixed');

    if ($body.hasClass('is-fixed')) {
      scrollPosition = $(window).scrollTop();
      $body.css('top', -scrollPosition);
    } else {
      $(window).scrollTop(scrollPosition);
      $body.css('top', '');
    }

    if ($nav.hasClass('is-active')) {
      setTimeout(function () {
        $logoWrap.toggleClass('is-show');
      }, 500);
    } else {
      $logoWrap.toggleClass('is-show');
    }

    if ($('.js-reverseHeader').hasClass('-reverse')) {
      $imgWhite.toggleClass('is-show');
      $imgBlack.toggleClass('is-show');
    }

    // Set the viewport height when the hamburger button is clicked
    setVhProperty();
  });
}
